import React from 'react';

import { HttpClientContext } from './HttpClientContext';

export function HttpClientProvider({ httpClient, children }) {
  return <HttpClientContext.Provider value={httpClient}>{children}</HttpClientContext.Provider>;
}
